import axios from 'axios';
import { createAction } from 'redux-actions';
import _ from 'lodash';
import { showNotification } from './notification_actions';

const instance = axios.create({
  baseURL: process.env.EVENTVIEWER_SERVER,
});

const wixParam = `${window.location.search}`;

export const startLoading = createAction('START_LOADING');
export const endLoading = createAction('END_LOADING');
export const fetchUser = createAction('FETCH_USER');
export const fetchSettings = createAction('FETCH_SETTINGS');
export const fetchEvents = createAction('FETCH_EVENTS');
export const updateSettings = createAction('UPDATE_SETTING');
export const updateSettingsProp = createAction('UPDATE_SETTING_PROPERTY');
export const fetchOrganizers = createAction('FETCH_ORGANIZERS');

function showErrorNotification(dispatch, { response }) {
  return dispatch(
    showNotification({
      type: 'error',
      message:
        response && !_.isEmpty(response.data)
          ? response.data.error
          : 'Problem connecting to Event Viewer',
    })
  );
}

export const getSettings = () => dispatch => {
  dispatch(startLoading());
  return instance
    .get(`/api/v1/config${wixParam}`)
    .then(res => {
      dispatch(fetchSettings(res.data));
      dispatch(endLoading());
      return res.data;
    })
    .catch(err => showErrorNotification(dispatch, err));
};

export const getEvents = () => dispatch => {
  dispatch(startLoading());
  return instance
    .get(`/api/v1/events${wixParam}`)
    .then(res => {
      dispatch(fetchEvents(res.data));
      dispatch(endLoading());
      return res.data;
    })
    .catch(err => showErrorNotification(dispatch, err));
};

export const createEvent = () => dispatch =>
  instance.post(`/api/v1/events${wixParam}`).catch(err => showErrorNotification(dispatch, err));

export const getUser = () => dispatch =>
  instance
    .get(`/api/v1/users/${wixParam}`)
    .then(res => {
      dispatch(fetchUser(res.data));
      return res.data;
    })
    .catch(() => dispatch(fetchUser({})));
export const getGoogleUser = id => dispatch => {
  if (!id) {
    return Promise.resolve();
  }
  return instance
    .get(`/api/v1/google-users${wixParam}`)
    .then(res => {
      dispatch(fetchUser(res.data));
      return res.data;
    })
    .catch(() => dispatch(fetchUser({})));
};

export const getOrganizers = () => dispatch =>
  instance
    .get(`/api/v1/events/organizers${wixParam}`)
    .then(res => {
      dispatch(fetchOrganizers(res.data));
      return res.data;
    })
    .catch(err => showErrorNotification(dispatch, err));

export const publish = () => instance.post(`/api/v1/publish${wixParam}`);

export const updateSettingsState = (key, value) => dispatch => {
  dispatch(updateSettingsProp({ key, value }));
};

export const updateSettingsProperty = (key, value) => dispatch =>
  instance
    .put(`/api/v1/config${wixParam}`, { [key]: value })
    .then(() => {
      dispatch(updateSettingsProp({ key, value }));
    })
    .catch(err => {
      Raven.captureException(err, { instance: Wix.Utils.getInstanceId() });
      return showErrorNotification(dispatch, err);
    });

export const deleteComponent = () => instance.delete(`/config${wixParam}`);

export const verifyUser = () => dispatch =>
  instance
    .put(`/api/v1/config/user_validate${wixParam}`, {}, { withCredentials: true })
    .then(({ data }) => {
      dispatch(fetchUser(data));
    });
export const verifyGoogleUser = () => dispatch =>
  instance
    .put(`/api/v1/config/google_user_validate${wixParam}`, {}, { withCredentials: true })
    .then(({ data }) => {
      dispatch(fetchUser(data));
    });

export const deleteSettings = () => instance.delete(`/api/v1/config${wixParam}`);



// WEBPACK FOOTER //
// ./src/actions/component_actions.js